import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { setSeo } from "@/utils/seo";

export default function NotFound() {
  useEffect(() => {
    setSeo(
      "Pagina non trovata | HairHelp",
      "La pagina che cerchi non esiste o è stata spostata. Torna alla home di HairHelp."
    );
  }, []);

  return (
    <div className="min-h-screen bg-ivory font-manrope text-charcoal" data-testid="notfound-page">
      <header className="bg-black" data-testid="notfound-header">
        <div className="mx-auto max-w-6xl px-4 py-4 md:px-6 md:py-6">
          <Link to="/" className="block" data-testid="notfound-logo-link">
            <img
              src="/logo-masthead.png"
              alt="HairHelp — Real Experience. Real Solutions."
              className="w-full rounded-2xl"
              data-testid="notfound-logo"
            />
          </Link>
        </div>
      </header>
      <div className="h-8 bg-gradient-to-b from-black to-transparent md:h-10" />

      <section className="mx-auto flex max-w-2xl flex-col items-center px-6 py-20 text-center md:py-28" data-testid="notfound-content">
        <span className="font-editorial text-6xl font-semibold text-sage md:text-7xl" data-testid="notfound-code">404</span>
        <h1 className="mt-6 font-editorial text-[2rem] font-semibold leading-tight text-charcoal md:text-[2.5rem]" data-testid="notfound-title">
          Pagina non trovata
        </h1>
        <p className="mt-5 max-w-md font-manrope text-base leading-relaxed text-charcoal/70 md:text-lg" data-testid="notfound-text">
          La pagina che cerchi non esiste o è stata spostata. Torniamo insieme al punto di partenza.
        </p>
        <Link
          to="/"
          data-testid="notfound-home-cta"
          className="mt-9 inline-flex min-h-[48px] items-center justify-center gap-2 rounded-xl bg-sage px-7 py-3.5 font-manrope text-[15px] font-semibold text-ivory shadow-[0_10px_24px_rgba(63,90,82,0.20)] transition-all duration-300 hover:bg-[#33463f] active:scale-[0.98]"
        >
          <ArrowLeft className="h-4 w-4" /> Torna alla Home
        </Link>
      </section>
    </div>
  );
}
